import { render, staticRenderFns } from "./ApplicationSubmitted.vue?vue&type=template&id=4d55e134"
import script from "./ApplicationSubmitted.vue?vue&type=script&lang=js"
export * from "./ApplicationSubmitted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports